import { getSemestresService } from "../helpers/services";

// FUNCIONES RELACIONADOS A SEMESTRES

export const getSemestres = async ({ commit }, values) => {
  const response = await getSemestresService(values);
  return response;
};